export default __webpack_public_path__ + "static/media/auto.ec068333.jpg";